<template>
  <div class="camp">
    <div class="header">
      <img src="https://exerland-bbs.oss-cn-shanghai.aliyuncs.com/user/042.png"/>
      <div class="right">
        <span class="name">这是训练营的名字</span>
        <span class="total">成员 120</span>
      </div>
    </div>
    <div class="cell photo-wall">
      <div class="header">
        <h3>照片锦集</h3>
        <span class="circle"></span>
      </div>
      <div class="img-box">
        <img src="https://exerlalnd.oss-cn-shanghai.aliyuncs.com/exerland-wechat/resource/image/后疫情时期的市场冲击和企业应对-刘方未.png?x-oss-process=image/resize,m_fill,w_981,h_321"/>
      </div>
    </div>
    <div class="cell curriculum">
      <div class="header">
        <h3>必修课程</h3>
        <span class="circle"></span>
      </div>
      <div class="panel-box" v-if="curriculum.length">
        <CurriculumItem v-for="item of curriculum" :key="item.id" v-bind="item"/>
      </div>
    </div>
    <div class="cell discussion">
      <div class="header">
        <h3>讨论分享</h3>
        <span class="circle"></span>
      </div>
      <div class="content">
        <DiscussionItem @deleteMessage="deleteMessage" @thumbsUp="thumbsUp(item)" v-for="item of files" :key="item.id" v-bind="item" />
      </div>
    </div>
  </div>
</template>
<script>
import { get } from '../../utils/request'
import CurriculumItem from './CurriculumItem'
import DiscussionItem from './DiscussionItem'
export default {
  components: {
    CurriculumItem,
    DiscussionItem
  },
  mounted () {
    this.getAllLiveList()
  },
  data () {
    return {
      curriculum: [],
      files: [
        {
          commentCount: 0,
          content: '我分享大家一个如何减肥的妙招',
          crateTime: '2020-06-15 08:18:57',
          files: {
            file: 'http://exerlalnd.oss-cn-shanghai.aliyuncs.com/wechat/font-face/%E4%BC%9A%E8%AE%AE%E7%BA%AA%E8%A6%81.docx',
            title: '如何让你在一天一夜减掉10斤赘肉？亲测有效docx'
          },
          id: 53,
          isRecommend: false,
          isUp: false,
          upCount: 1,
          user: {
            avatar: 'https://exerland-bbs.oss-cn-shanghai.aliyuncs.com/user/059.png',
            id: 7,
            isForbidden: false,
            nickName: '烦烦烦',
            signName: '',
            username: 'chenwg@fosun.com'
          }
        },
        {
          commentCount: 0,
          content: '我分享大家一个如何减肥的妙招',
          crateTime: '2020-06-15 08:18:57',
          files: {
            file: 'http://exerlalnd.oss-cn-shanghai.aliyuncs.com/wechat/font-face/%E5%85%B3%E4%BA%8E%E3%80%8A2020%E4%B8%8A%E6%B5%B7%E5%8D%9A%E7%89%A9%E3%80%81%E7%BE%8E%E6%9C%AF%E9%A6%86%E9%80%9A%E7%A5%A8%E3%80%8B%E9%9C%80%E6%B1%82%E7%BB%9F%E8%AE%A1%E7%9A%84%E9%80%9A%E7%9F%A5(1).pdf',
            title: '如何让你在一天一夜减掉10斤赘肉？亲测有效PDF'
          },
          id: 51,
          isRecommend: false,
          isUp: false,
          upCount: 1,
          user: {
            avatar: 'https://exerland-bbs.oss-cn-shanghai.aliyuncs.com/user/059.png',
            id: 7,
            isForbidden: false,
            nickName: '烦烦烦',
            signName: '',
            username: 'chenwg@fosun.com'
          }
        },
        {
          commentCount: 0,
          content: '我分享大家一个如何减肥的妙招',
          crateTime: '2020-06-15 08:18:57',
          files: {
            file: 'http://exerlalnd.oss-cn-shanghai.aliyuncs.com/wechat/font-face/%E6%88%98%E5%BD%B9%E5%AE%A3%E4%BC%A0(1)_50.xlsx',
            title: '如何让你在一天一夜减掉10斤赘肉？亲测有效xlsx'
          },
          id: 55,
          isRecommend: false,
          isUp: false,
          upCount: 1,
          user: {
            avatar: 'https://exerland-bbs.oss-cn-shanghai.aliyuncs.com/user/059.png',
            id: 7,
            isForbidden: false,
            nickName: '烦烦烦',
            signName: '',
            username: 'chenwg@fosun.com'
          }
        },
        {
          commentCount: 0,
          content: '我分享大家一个如何减肥的妙招',
          crateTime: '2020-06-15 08:18:57',
          files: {
            file: 'http://exerlalnd.oss-cn-shanghai.aliyuncs.com/wechat/font-face/%E7%A0%94%E5%8F%91%E6%B5%81%E7%A8%8B.pptx',
            title: 'pptx'
          },
          id: 545,
          isRecommend: false,
          isUp: false,
          upCount: 1,
          user: {
            avatar: 'https://exerland-bbs.oss-cn-shanghai.aliyuncs.com/user/059.png',
            id: 7,
            isForbidden: false,
            nickName: '烦烦烦',
            signName: '',
            username: 'chenwg@fosun.com'
          }
        }
      ],
      loading: false,
      count: 0,
      page: 1,
      size: 10
    }
  },
  methods: {
    getAllLiveList () {
      this.loading = true
      const url = `/course/h5CurriculumList?page=${this.page}&size=${this.size}`
      const promise = get({
        url
      })
      promise.then(res => {
        const { data: { code, detail: { count, list } } } = res
        if (Object.is(code, 200)) {
          this.curriculum = list
          this.count = count
          this.loading = false
        }
      })
    },
    deleteMessage (id) {
      let index = 0
      this.files.forEach((item, _index) => {
        if (Object.is(id, item.id)) {
          index = _index
        }
      })
      this.files.splice(index, 1)
    },
    thumbsUp (item) {
      item.isUp = !item.isUp
      let count = item.upCount
      if (item.isUp) {
        ++count
      } else {
        --count
      }
      item.upCount = count
    }
  }
}
</script>
<style lang="scss" scoped>
.camp {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding: 0 16px;
  .header {
    padding-top: 6px;
    display: flex;
    img {
      width: 72px;
      height: 72px;
      border-radius: 50%;
      display: inline-block;
    }
    .right {
      margin-left: 12px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .name {
        font-size:20px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:28px;
        display: block;
        margin-bottom: 11px;
      }
      .total {
        font-size:13px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(0,0,0,1);
        line-height:18px;
      }
    }
  }
  .cell {
    .header {
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      h3 {
        font-size:20px;
        font-family:AlibabaPuHuiTi-Medium,AlibabaPuHuiTi;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:27px;
        margin-right: 8px;
      }
      .circle {
        width: 8px;
        height: 8px;
        border:2px solid rgba(24,204,159,1);
        border-radius: 50%;
        margin-bottom: 4px;
      }
    }
  }
  .photo-wall {
    width: 100%;
    margin-top: 33px;
    .img-box {
      box-align: border;
      background:rgba(245,245,245,1);
      padding: 7px 10px;
      margin-top: 9px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .curriculum {
    margin-top: 19px;
    .panel-box {
      margin: 0 auto 0;
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
  }
  .discussion {
    margin-top: 31px;
  }
}
</style>
